<template>
  <div>
    <!-- 筛选区 -->
    <div class="search-section search-section-new">
      <form class="search-form-2x2">
        <div class="form-fields">
          <div class="form-item">
            <label>设备类型：</label>
            <select class="form-input" v-model="query.deviceType">
              <option value="">全部</option>
              <option value="温湿度表">温湿度表</option>
              <option value="压力表">压力表</option>
            </select>
          </div>
          <div class="form-item">
            <label>所属厂区：</label>
            <select class="form-input" v-model="query.park">
              <option value="">全部</option>
              <option v-for="area in options.park" :key="area" :value="area">{{ area }}</option>
            </select>
          </div>
          <div class="form-item">
            <label>所属楼号：</label>
            <select class="form-input" v-model="query.building">
              <option value="">全部</option>
              <option v-for="building in options.building" :key="building" :value="building">{{ building }}</option>
            </select>
          </div>

          <div class="form-item">
            <label>所属楼层：</label>
            <select class="form-input" v-model="query.floor">
              <option value="">全部</option>
              <option v-for="floor in options.floor" :key="floor" :value="floor">{{ floor }}</option>
            </select>
          </div>
          <!-- <div class="form-item">
            <label>设备名称</label>
            <input class="form-input" v-model="query.deviceName" placeholder="设备名称" />
          </div> -->
          <div class="form-item">
            <label>日期：</label>
            <input class="form-input" type="date" v-model="query.date" />
          </div>
        </div>
        <div class="form-btns">
          <!-- <button type="button" class="search-btn-green" @click="onPrint">打印</button> -->
          <button type="button" class="search-btn-green" @click="onSearch">搜索</button>
          <button type="button" class="search-btn-green" @click="printData">打印</button>
        </div>
      </form>
    </div>
    
    <!-- 表格 -->
    <div class="data-section">
      <div class="table-container">
        <table class="data-table">
          <thead>
            <tr>
              <th>序号</th>
              <th>设备编号</th>
              <th>设备名称</th>
              <th>设备类型</th>
              <th>平均数</th>
              <th>安装位置</th>
              <th>更新时间</th>
              <th>录入方式</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="loading">
              <td colspan="9" style="text-align:center;color:#bbb;">数据加载..</td>
            </tr>
            <tr v-else-if="historyList.length === 0">
              <td colspan="9" style="text-align:center;color:#bbb;">暂无数据</td>
            </tr>
            <template v-if="historyList.length > 0">
              <tr v-for="(item, idx) in historyList" :key="item.id">
                <td>{{ (page-1)*pageSize + idx + 1 }}</td>
                <td>{{ item.deviceNumber }}</td>
                <td>{{ item.deviceName }}</td>
                <td>{{ item.deviceType }}</td>
                <td>{{ item.averageValue }}</td>
                <td>{{ item.installLocation }}</td>
                <td>{{ item.updateTime }}</td>
                <td>{{ item.entryMethod }}</td>
                <td>
                  <button class="search-btn-green" style="padding:4px 8px;font-size:14px;" @click="generateChart(item)">
                    生成折线
                  </button>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      
      <!-- 分页 -->
      <div class="pagination">
        <button class="page-btn" :disabled="page===1" @click="page=1;loadData()">«</button>
        <button class="page-btn" :disabled="page===1" @click="page--;loadData()">&lt;</button>
        <span v-for="p in displayPages" :key="p">
          <button class="page-btn" :class="{active:page===p}" @click="page=p;loadData()">{{p}}</button>
        </span>
        <button class="page-btn" :disabled="page===totalPages" @click="page++;loadData()">&gt;</button>
        <button class="page-btn" :disabled="page===totalPages" @click="page=totalPages;loadData()">»</button>
        <div class="page-jump">
          <input type="text" v-model="pageInput" style="width:50px;" />
          <button class="jump-btn" @click="jumpPage">跳转</button>
        </div>
      </div>
    </div>
    
    <!-- 历史详情弹窗 -->
    <div v-if="showDetailForm" class="modal-mask" style="position:fixed;left:0;top:0;width:100vw;height:100vh;background:#0003;z-index:1000;display:flex;align-items:center;justify-content:center;">
      <div class="modal-content" style="background:#fff;padding:40px 60px 32px 60px;border-radius:8px;min-width:800px;position:relative;">
        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:32px;">
          <span style="font-size:22px;color:#1976d2;font-weight:bold;border-bottom:3px solid #1976d2;padding-bottom:4px;">历史数据详情</span>
          <button @click="closeDetailForm" style="background:none;border:none;font-size:28px;cursor:pointer;line-height:1;">×</button>
        </div>
        <div class="edit-form">
          <div class="edit-form-row">
            <label>设备名称</label>
            <input :value="currentDevice.deviceName" class="form-input" readonly />
          </div>
          <div class="edit-form-row">
            <label>设备编号</label>
            <input :value="currentDevice.deviceNumber" class="form-input" readonly />
          </div>
          <div class="edit-form-row">
            <label>设备类型</label>
            <input :value="currentDevice.deviceType" class="form-input" readonly />
          </div>
          <div class="edit-form-row">
            <label>安装位置</label>
            <input :value="currentDevice.installLocation" class="form-input" readonly />
          </div>
          <div class="edit-form-row">
            <label>平均数值：</label>
            <input :value="currentDevice.averageValue" class="form-input" readonly />
          </div>
          <div class="edit-form-row">
            <label>更新时间</label>
            <input :value="currentDevice.updateTime" class="form-input" readonly />
          </div>
          <div class="edit-form-row">
            <label>录入方式</label>
            <input :value="currentDevice.entryMethod" class="form-input" readonly />
          </div>
        </div>
        <div style="text-align:center;margin-top:24px;">
          <button type="button" class="search-btn-green" style="width:160px;background:#eee;color:#333;" @click="closeDetailForm">关闭</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { HTTP_CONFIG } from '@/config/config.js'

export default {
  name: 'EnvHistory',
  data() {
    return {
      query: {
        deviceType: '',
        park: '',
        building: '',
        detailLocation: '',
        floor: '',
        deviceName: '',
        date: ''
      },
      page: 1,
      pageSize: 10,
      pageInput: '1',
      total: 0,
      totalPages: 1,
      loading: false,
      showDetailForm: false,
      currentDevice: {},
      historyList: [],
      // 动态选项数组
      options: {
        park: [],
        building: [],
        detailLocation: [],
        floor: []
      },
      lastQuery: null
    }
  },
  computed: {
    // 删除 pagedList 计算属性，直接使用 historyList
    // 删除 totalPages 计算属性，使用 data 中的 totalPages
    
    // 新增：生成显示的页码范围，最多显示10页
    displayPages() {
      const total = this.totalPages;
      const current = this.page;
      const maxDisplay = 10;
      
      if (total <= maxDisplay) {
        return Array.from({ length: total }, (_, i) => i + 1);
      }
      
      let start = Math.max(1, current - Math.floor(maxDisplay / 2));
      let end = Math.min(total, start + maxDisplay - 1);
      
      if (end - start + 1 < maxDisplay) {
        start = Math.max(1, end - maxDisplay + 1);
      }
      
      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    }
  },
  watch: {
    'query.park'() {
      this.updateOptions();
    },
    'query.building'() {
      this.updateOptions();
    },
    'query.floor'() {
      this.updateOptions();
    },
    'query.deviceType'() {
      this.updateOptions();
    }
  },
  mounted() {
    this.loadData();
    this.fetchOptions();
    // 设置默认日期为今天
    const today = new Date().toISOString().split('T')[0];
    this.query.date = today;
  },
  methods: {
    // 获取所有选项数据
    async fetchOptions() {
      try {
        await Promise.all([
          this.fetchParkOptions(),
          this.fetchBuildingOptions(),
          this.fetchFloorOptions(),
          this.fetchDetailLocationOptions()
        ]);
      } catch (error) {
        console.error('获取选项数据失败:', error);
      }
    },

    // 获取厂区选项
    async fetchParkOptions() {
      try {
        const params = {};
        if (this.query.deviceType === '温湿度表') {
          params.fac_type = '0';
        } else if (this.query.deviceType === '压力表') {
          params.fac_type = '1';
        }
        if (this.query.building) params.building_number = this.query.building;
        if (this.query.floor) params.floor = this.query.floor;
        
        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/environment/query_fac_area_list/?${new URLSearchParams(params)}`);
        const data = await response.json();
        
        if (data && data.factory_area) {
          this.options.park = Array.from(data.factory_area).filter(Boolean);
        }
      } catch (error) {
        console.error('获取厂区选项失败:', error);
      }
    },

    // 获取楼号选项
    async fetchBuildingOptions() {
      try {
        const params = {};
        if (this.query.deviceType === '温湿度表') {
          params.fac_type = '0';
        } else if (this.query.deviceType === '压力表') {
          params.fac_type = '1';
        }
        if (this.query.park) params.factory_area = this.query.park;
        if (this.query.floor) params.floor = this.query.floor;
        
        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/environment/query_building_number_list/?${new URLSearchParams(params)}`);
        const data = await response.json();
        
        if (data && data.building_number) {
          this.options.building = Array.from(data.building_number).filter(Boolean);
        }
      } catch (error) {
        console.error('获取楼号选项失败:', error);
      }
    },

    // 获取楼层选项
    async fetchFloorOptions() {
      try {
        const params = {};
        if (this.query.deviceType === '温湿度表') {
          params.fac_type = '0';
        } else if (this.query.deviceType === '压力表') {
          params.fac_type = '1';
        }
        if (this.query.park) params.factory_area = this.query.park;
        if (this.query.building) params.building_number = this.query.building;
        
        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/environment/query_floor_list/?${new URLSearchParams(params)}`);
        const data = await response.json();
        
        if (data && data.floor) {
          this.options.floor = Array.from(data.floor).filter(Boolean);
        }
      } catch (error) {
        console.error('获取楼层选项失败:', error);
      }
    },

    // 获取详细位置选项
    async fetchDetailLocationOptions() {
      try {
        const params = new URLSearchParams();
        
        // 根据设备类型设置fac_type
        if (this.query.deviceType === '温湿度表') {
          params.append('fac_type', '0');
        } else if (this.query.deviceType === '压力表') {
          params.append('fac_type', '1');
        }
        
        // 添加其他筛选参 
        if (this.query.park) {
          params.append('factory_area', this.query.park);
        }
        if (this.query.building) {
          params.append('building_number', this.query.building);
        }
        if (this.query.floor) {
          params.append('floor', this.query.floor);
        }
        
        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/environment/query_install_area_list/?${params}`);
        const data = await response.json();
        
        if (data && Array.isArray(data)) {
          this.options.detailLocation = data.filter(Boolean);
        } 
      } catch (error) {
        console.error('获取详细位置选项失败:', error);
      }
    },

    // 智能更新选项
    async updateOptions() {
      try {
        const promises = [];
        
        if (this.query.deviceType !== this.lastQuery?.deviceType) {
          promises.push(
            this.fetchParkOptions(),
            this.fetchBuildingOptions(),
            this.fetchFloorOptions(),
            this.fetchDetailLocationOptions()
          );
        }
        else if (this.query.park !== this.lastQuery?.park) {
          promises.push(
            this.fetchBuildingOptions(),
            this.fetchFloorOptions()
          );
        }
        else if (this.query.building !== this.lastQuery?.building) {
          promises.push(this.fetchFloorOptions());
        }
        
        if (promises.length > 0) {
          await Promise.all(promises);
        }
        
        this.lastQuery = { 
          deviceType: this.query.deviceType,
          park: this.query.park,
          building: this.query.building,
          floor: this.query.floor
        };
      } catch (error) {
        console.error('更新选项失败:', error);
      }
    },

    async loadData() {
      this.loading = true;
      try {
        // 使用新的统一接口
        await this.loadHistoryData();
      } catch (error) {
        console.error('加载历史数据失败:', error);
        // 使用模拟数据作为备 
        this.historyList = this.getMockData();
      } finally {
        this.loading = false;
      }
    },
    
    formataverageValue(item) {
      let averageValue = null
      if(item.average_data != '') {
        let average = item.average_data.toString()
        if(item.fac_name === '气压力表') {
          let matchs = average.match(/\d+/g)
          if(matchs != null) {
            let value = parseFloat(matchs[0]) / 1000
            value = value.toFixed(2)
            averageValue = value.toString() + "MPa"
          }
        }
        else if(item.fac_name === '温湿度表') {
          let average = item.average_data.toString()
          let matchs = average.match(/[-]?\d+\.\d\d/g)
          if(matchs.length == 2) averageValue = matchs[0] + '℃/' + matchs[1] + '%RH'
          else averageValue = average
        }
      }
      return averageValue;
    },
    async loadHistoryData() {
      try {
        const params = this.buildQueryParams();
        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/environment/query_history_meter_data/?${params}`);
        const data = await response.json();
        
        if (data && data.data) {
          this.historyList = data.data.map(item => ({
              id: item.fac_id,
              deviceNumber: item.fac_id,
              deviceName: item.fac_name || '未命名',
              deviceType: item.fac_type || '未知',
              averageValue: this.formataverageValue(item) || '未知',
              installLocation: this.formatLocationFromAPI(item),
              updateTime: this.query.date || new Date().toISOString().split('T')[0],
              entryMethod: '自动抄表'
          }));
          
          // 更新分页信息
          this.total = data.total || this.historyList.length;
          this.totalPages = data.total_pages || Math.max(1, Math.ceil(this.total / this.pageSize));
        } else {
          this.historyList = [];
          this.total = 0;
          this.totalPages = 1;
        }
      } catch (error) {
        console.error('加载历史数据失败:', error);
        throw error;
      }
    },
    
    // 从API数据格式化位置信 
    formatLocationFromAPI(item) {
      const parts = [];
      if (item.factory_area) parts.push(item.factory_area);
      if (item.building_number) parts.push(item.building_number);
      if (item.floor) parts.push(item.floor);
      if (item.install_area) parts.push(item.install_area);
      
      return parts.length > 0 ? parts.join('') : '泰山路园105号楼四层';
    },
    
    // 获取模拟数据
    getMockData(deviceType = null) {
      if (!deviceType) {
        // 如果没有指定设备类型，返回混合数 
        return [
          {

          }
          
        ];
      }
      
      // 如果指定了设备类型，返回对应类型的数 
      return [
        {
    
        }
      ];
    },
    buildPrintQueryParams() {
      const params = new URLSearchParams();
      
      // 设备类型转换为fac_type参数
      if (this.query.deviceType === '温湿度表') {
        params.append('fac_type', '0');
        } else if (this.query.deviceType === '压力表') {
        params.append('fac_type', '1');
      }
      
      if (this.query.park) {
        params.append('factory_area', this.query.park);
      }
      if (this.query.building) {
        params.append('building_number', this.query.building);
      }
      if (this.query.detailLocation) {
        params.append('install_area', this.query.detailLocation);
      }
      if (this.query.floor) {
        params.append('floor', this.query.floor);
      }
      if (this.query.deviceName) {
        params.append('fac_name', this.query.deviceName);
      }
      if (this.query.date) {
        params.append('target_date', this.query.date);
      }
      
      // 设置分页参数获取所有数据
      params.append('page', 1);
      params.append('per_page', 500); // 设置每页500条数据
      
      return params.toString();
    },
    getQueryConditions() {
      const conditions = [];
      if (this.query.deviceType) conditions.push(`设备类型: ${this.query.deviceType}`);
      if (this.query.park) conditions.push(`厂区: ${this.query.park}`);
      if (this.query.building) conditions.push(`楼号: ${this.query.building}`);
      if (this.query.floor) conditions.push(`楼层: ${this.query.floor}`);
      if (this.query.date) conditions.push(`日期: ${this.query.date}`);
      
      return conditions.length > 0 ? conditions.join(', ') : '全部';
    },
    getDeviceTypeName(facType) {
      const typeMap = {
        '0': '温湿度表',
        '1': '压力表'
      };
      return typeMap[facType] || facType || '-';
    },
    async printData() {
      try {
        console.log('=== 开始打印环境历史数据 ===');
        
        // 构建查询参数，设置per_page为500获取所有数据
        const params = this.buildPrintQueryParams();
        
        console.log('打印查询参数:', params);
        
        // 调用API获取所有数据 - 使用历史数据接口
        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/environment/query_history_meter_data/?${params}`);
        const data = await response.json();
        
        let allData = [];
        
        if (data && data.data) {
          allData = data.data.map(item => ({
            id: item.fac_id,
            deviceNumber: item.fac_id,
            deviceName: item.fac_name || '未命名',
            deviceType: this.getDeviceTypeName(item.fac_type),
            averageValue: item.average_data || '未知',
            installLocation: this.formatLocationFromAPI(item),
            updateTime: this.query.date || new Date().toISOString().split('T')[0],
            entryMethod: '自动抄表'
          }));
          
          console.log('API返回数据:', allData);
          console.log('数据数组长度:', allData.length);
        } else {
          console.error('获取打印数据失败:', data);
          allData = this.historyList;
        }

        // 生成打印内容
        const printContent = `
          <div style="padding: 20px;">
            <h2 style="text-align: center; margin-bottom: 20px;">环境历史数据列表</h2>
            <div style="margin-bottom: 10px; text-align: right; color: #666;">
              打印时间: ${new Date().toLocaleString('zh-CN')}
            </div>
            <div style="margin-bottom: 10px; text-align: right; color: #666;">
              总记录数: ${allData.length} 条
            </div>
            <div style="margin-bottom: 10px; text-align: left; color: #666;">
              查询条件: ${this.getQueryConditions()}
            </div>
            <table style="width: 100%; border-collapse: collapse; border: 1px solid #ddd;">
              <thead>
                <tr style="background: #f5f5f5;">
                  <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">序号</th>
                  <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">设备编号</th>
                  <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">设备名称</th>
                  <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">设备类型</th>
                  <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">平均数</th>
                  <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">安装位置</th>
                  <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">更新时间</th>
                  <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">录入方式</th>
                </tr>
              </thead>
              <tbody>
                ${allData.map((item, index) => `
                  <tr>
                    <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${index + 1}</td>
                    <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.deviceNumber || '-'}</td>
                    <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.deviceName || '-'}</td>
                    <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.deviceType || '-'}</td>
                    <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.averageValue || '-'}</td>
                    <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.installLocation || '-'}</td>
                    <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.updateTime || '-'}</td>
                    <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.entryMethod || '-'}</td>
                  </tr>
                `).join('')}
              </tbody>
            </table>
          </div>
        `;
        
        // 打开打印窗口
        const printWindow = window.open('', '_blank');
        printWindow.document.write(printContent);
        printWindow.document.close();
        printWindow.print();
        printWindow.close();
        
        console.log('=== 环境历史数据打印完成 ===');
        
      } catch (error) {
        console.error('打印环境历史数据失败:', error);
        alert('打印失败，请查看控制台');
      }
    },    
    buildQueryParams() {
      const params = new URLSearchParams();
      
      // 设备类型转换为fac_type参数
      if (this.query.deviceType === '温湿度表') {
        params.append('fac_type', '0');
        } else if (this.query.deviceType === '压力表') {
        params.append('fac_type', '1');
      }
      
      if (this.query.park) {
        params.append('factory_area', this.query.park);
      }
      if (this.query.building) {
        params.append('building_number', this.query.building);
      }
      if (this.query.detailLocation) {
        params.append('install_area', this.query.detailLocation);
      }
      if (this.query.floor) {
        params.append('floor', this.query.floor);
      }
      if (this.query.deviceName) {
        params.append('fac_name', this.query.deviceName);
      }
      if (this.query.date) {
        params.append('target_date', this.query.date);
      }
      
      params.append('page', this.page);
      params.append('per_page', this.pageSize);
      
      return params.toString();
    },
    
    onSearch() {
      this.page = 1;
      this.loadData();
    },
    
    onPrint() {
      // 实现打印功能
      window.print();
    },
    
    jumpPage() {
      let p = parseInt(this.pageInput);
      if (!isNaN(p) && p >= 1 && p <= this.totalPages) {
        this.page = p;
        this.loadData();
      }
    },
    
    generateChart(item) {
      console.log(item)
      console.log('跳转到图表页面，参数:', {
        fac_id: item.deviceNumber,
        deviceName: item.deviceName,
        deviceType: item.deviceType,
        targetDate: this.query.date
      });
      
      this.$router.push({
        path: '/home/history/chart',
        query: {
          fac_id: item.deviceNumber,
          deviceName: item.deviceName,
          deviceType: item.deviceType,
          targetDate: this.query.date
        }
      }).then(() => {
        console.log('路由跳转成功');
      }).catch(err => {
        console.error('路由跳转失败:', err);
      });
    },
    
    closeDetailForm() {
      this.showDetailForm = false;
      this.currentDevice = {};
    }
  }
}
</script>

<style scoped>
/* 弹窗样式 */
.edit-form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.edit-form-row {
  display: flex;
  align-items: center;
}

.edit-form-row label {
  color: #222;
  font-size: 16px;
  min-width: 120px;
  text-align: right;
  margin-right: 12px;
}

.edit-form-row .form-input {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 15px;
  min-width: 200px;
  outline: none;
  transition: border 0.2s;
}

.edit-form-row .form-input:focus {
  border: 1.5px solid #4caf50;
}

.edit-form-row select.form-input {
  min-width: 200px;
}

.required {
  color: #e74c3c;
  margin-right: 4px;
}

/* 弹窗内容区域样式 */
.modal-content {
  max-height: 80vh;
  overflow-y: auto;
}

  /* 响应式设 */
@media (max-width: 768px) {
  .edit-form-row {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .edit-form-row label {
    min-width: auto;
    margin-bottom: 8px;
  }
  
  .edit-form-row .form-input {
    min-width: 100%;
  }
}
</style>
